import cn from "clsx";
import { useId } from "react";
import styles from "./InfoTable.module.scss";

type InfoTableRowProps = React.PropsWithChildren<{
    header: React.ReactNode;
    hideSeparator?: boolean;
}>;

export const InfoTableRow: React.FC<InfoTableRowProps> = ({
    children,
    header,
    hideSeparator,
}) => {
    const rowId = useId();
    return (
        <div
            role="group"
            aria-labelledby={rowId}
            className={cn(styles.row, {
                [styles["row--no-separator"]]: hideSeparator,
            })}
        >
            <div>{header}</div>
            <div className={styles["row-content"]}>{children}</div>
        </div>
    );
};
